import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
export const datasource = createCrudVuexModule({
  namespaced: true,
  path: "/library/datasource",

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }
        const response = await rest.post(`/recommendation/paginate/${level}/${id}`, { pagination });
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});

export const workspaceDatasource = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/datasource",
});

export const managementDatasource = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/datasource",
});
